/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsViewerAliases {
  ACTION_INACTIVATE_INTAKES_OUTPUTS = 'action-inactivate-intakes-outputs',
  ACTION_NEW_INTAKES_OUTPUTS = 'action-new-intakes-outputs',
  CONTEXTUAL_BAR_INTAKES_VIEWER = 'contextual-bar-intakes-viewer',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FIELD_DEVICE = 'field-device',
  FIELD_GROUP_DESCRIPTION = 'field-group-description',
  FIELD_INCIDENTS_QUANTITY = 'field-incidents-quantity',
  FIELD_NOTES_DESCRIPTION = 'field-notes-description',
  FIELD_PREOFESSIONAL_NAME = 'field-preofessional-name',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_RECORD_TIME = 'field-record-time',
  FIELD_SIDE = 'field-side',
  FIELD_TOPOGRAPHY = 'field-topography',
  FIELD_TYPE = 'field-type',
  FIELD_VOLUME_QUANTITY = 'field-volume-quantity',
  FIELD_WEIGHT_QUANTITY = 'field-weight-quantity',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FORM_INTAKES_OUTPUTS_VIEWER = 'form-intakes-outputs-viewer',
  HTML_VIEWER_NOTES_DESCRIPTION = 'html-viewer-notes-description',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_RECORD_DATE = 'input-record-date',
  INTAKES_AND_OUTPUTS_VIEWER_LAYOUT = 'intakes-and-outputs-viewer-layout',
  INTAKES_OPTION = 'intakes-option',
  MODAL_ACTIONS = 'modal-actions',
  OUTPUTS_OPTION = 'outputs-option',
  PANEL_ACTIONS = 'panel-actions',
  TEXT_DEVICE = 'text-device',
  TEXT_GROUP_DESCRIPTION = 'text-group-description',
  TEXT_INCIDENTS_QUANTITY = 'text-incidents-quantity',
  TEXT_PROFESSIONAL_NAME = 'text-professional-name',
  TEXT_RECORD_TIME = 'text-record-time',
  TEXT_SIDE = 'text-side',
  TEXT_TOPOGRAPHY = 'text-topography',
  TEXT_TYPE = 'text-type',
  TEXT_VOLUME_QUANTITY = 'text-volume-quantity',
  TEXT_WEIGHT_QUANTITY = 'text-weight-quantity',
}
export { IntakesAndOutputsViewerAliases };
